import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-b border-steelLine bg-charcoal px-4 py-8 sm:py-10" data-id="element-28" data-mp="1hd1nvzbcra01">
      <div className="mx-auto max-w-3xl" data-id="element-29" data-mp="1cei2c00o8087">
        <h2 className="text-center text-xl text-white sm:text-3xl" data-id="element-30" data-mp="1cfjfqb55syt3">Frequently Asked Questions</h2>
        <ul className="mt-4 divide-y divide-steelLine overflow-hidden rounded-md border border-steelLine bg-steel" data-id="element-31" data-mp="2a176afexomwp">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} data-id="element-32" data-mp="2027yez1zsvar" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-3.5 py-2.5 text-left transition-colors duration-150 ease-out hover:bg-charcoal focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-33" data-mp="1v583nkalfeyy">
                  <span className="font-display text-xs font-extrabold uppercase tracking-wide text-white sm:text-sm" data-id="element-34" data-mp="1pmjp6qhu88t3">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-gold transition-transform duration-150 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-35" data-mp="1arx0bi0kiucq" />
                </button>
                {isOpen ? <p className="px-3.5 pb-3 text-sm font-medium leading-snug text-lightGray" data-id="element-36" data-mp="rzkv8nij5eyw">{faq.answer}</p> : null}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}